module.exports = __webpack_public_path__ + "img/second-1.1e56a5b3.webp";